<template>
  <div>
    <el-scrollbar class="drill-version">
      <el-tabs tab-position="left" v-model="serialNumber">
        <el-tab-pane
          v-for="v in versions"
          :label="v"
          :key="v"
          :name="v"
        ></el-tab-pane>
      </el-tabs>
    </el-scrollbar>

    <div style="padding-left: 130px" v-if="drill.id">
      <div class="panel customer-info-panel mt-20">
        <div class="header customer-info-title flex-row-between">
          <!-- <h5>序列号：{{ serialNumber }}</h5> -->
          <el-row :gutter="24">
            <el-col :span="6"
              ><div class="grid-content">
                型号：{{ drill.model_number }}
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content">
                零件号：{{ drill.component_number }}
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content">
                类型：{{ DrillTypeMap[drill.drill_type] }}
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content">
                规格：{{ drill.specification }}
              </div></el-col
            >
          </el-row>
        </div>
      </div>
      <div class="panel mt-20">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="订单信息" name="first"> </el-tab-pane>
          <el-tab-pane label="生产信息" name="second"></el-tab-pane>
          <el-tab-pane label="复合片记录" name="third"></el-tab-pane>
          <el-tab-pane label="库存信息" name="fourth"></el-tab-pane>
          <el-tab-pane label="项目信息" name="fifth"></el-tab-pane>
        </el-tabs>
      </div>

      <OrderTab
        v-if="activeTab == 'first'"
        :serialNumber="serialNumber"
      ></OrderTab>
      <ProduceTab
        v-if="activeTab == 'second'"
        :serialNumber="serialNumber"
      ></ProduceTab>
      <PdcTab v-if="activeTab == 'third'" :serialNumber="serialNumber"></PdcTab>
      <StockTab
        v-if="activeTab == 'fourth'"
        :serialNumber="serialNumber"
      ></StockTab>
      <ReportTab
        v-if="activeTab == 'fifth'"
        :serialNumber="serialNumber"
      ></ReportTab>
    </div>

    <div v-else class="text-center" style="line-height: 200px">序列号错误!</div>
  </div>
</template>

<script>
import OrderTab from './order_tab.vue'
import ProduceTab from './produce_tab.vue'
import PdcTab from './pdc_tab.vue'
import ReportTab from './report_tab.vue'
import StockTab from './stock_tab.vue'
import { drillBaseInfo } from '@/service/getData'
import { DrillTypeMap } from '@/config/global'

export default {
  props: {
    serialNumber: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      DrillTypeMap,
      activeTab: 'first',
      // serialNumber: this.$route.params.serial_number,
      drill: {},
      versions: [],
    }
  },
  components: {
    // CommonHeader,
    OrderTab,
    ProduceTab,
    PdcTab,
    ReportTab,
    StockTab,
  },
  created() {
    this.activeTab = this.$route.query.tab || 'first'
    this.getData()
  },
  watch: {
    serialNumber() {
      this.getData()
    },
  },
  methods: {
    async getData() {
      let res = await drillBaseInfo(this.serialNumber)
      if (res.status == 0) {
        this.drill = res.data
        this.versions = res.data.versions
      } else {
        this.drill = {}
      }
    },
    handleClick(e) {
      this.$router.replace({ query: { tab: e.name } })
    },
  },
}
</script>

<style scoped>
#content-container {
  width: 1200px;
  margin: 0 auto;
  /* padding-left: 200px; */
  padding-right: 20px;
  margin-top: 30px;
}
.panel {
  padding: 16px 20px;
}

.drill-version {
  /* width: 200px; */
  position: fixed;
  /* left: 0; */
  /* top: 0px; */
  /* bottom: 0; */
  /* margin-top: 90px; */
}
</style>